import { useTranslation } from 'react-i18next';

import { type EsIndex } from '~/apps/product-plus/configuration/types.ts';
import {
  bettingSplitsIndex,
  matchupCentreIndex,
  positiveEvIndex,
  premiumMarketMoversIndex,
  trendsIndex,
} from '~/apps/product-plus/search-domain/indexes';
import { useRepubContext } from '~/providers/repub-context.tsx';

import { Card } from '../cxy/cxy.ts';

import styles from './Error.module.css';

const betNameLocale = {
  en: {
    [positiveEvIndex]: 'EV bets',
    [trendsIndex]: 'Trends bets',
    [bettingSplitsIndex]: 'Betting Splits bets',
    [matchupCentreIndex]: 'Matchup Centre bets',
    [premiumMarketMoversIndex]: 'Recommendations',
  },
  it: {
    [positiveEvIndex]: 'Scommesse di Valore',
    [trendsIndex]: 'Trend',
    [bettingSplitsIndex]: 'Scelte degli scommettitori',
    [matchupCentreIndex]: 'Match Center',
  },
};

const betNameMap = {
  OC: betNameLocale.en,
  GZ: betNameLocale.it,
  WS: betNameLocale.en,
  US: betNameLocale.en,
};

export function Error<TIndex extends EsIndex>({
  indexName,
  message,
  title,
}: {
  indexName: TIndex;
  message?: string;
  title?: string;
}) {
  const { t } = useTranslation();
  const { repub } = useRepubContext();

  // @ts-ignore
  const errorMessage = message || t('CX_PLUS_NO_BETS_AVAILABLE', { betName: betNameMap[repub][indexName] });
  return (
    <div className={styles.error} data-testid="error">
      <Card height="361px" padding="l" shouldCenter>
        {title ? <h1>{title}</h1> : ''}
        {errorMessage}
      </Card>
    </div>
  );
}
